import { useSelector, useDispatch } from 'react-redux'

import {
  legacyPlanWarning
} from 'features/billing/actions/legacy_plan_warning'
import {
  isLegacyPlanSelector,
  unableToChangeTierSelector,
} from 'features/billing/selectors'

export const useLegacyPlanWarning = () => {
  const isLegacyPlan = useSelector(isLegacyPlanSelector)
  const unableToChangeTier = useSelector(unableToChangeTierSelector)
  const dispatch = useDispatch()

  return legacyPlanWarning(dispatch, {
    isLegacyPlan,
    unableToChangeTier,
  })
}
